export const FOOTER_NEWSLETTER_CONTENT = {
  title: 'Get Practical Festival And Booking Updates',
  description: 'Receive monthly muhurat reminders, service availability alerts, and booking offers. No spam, unsubscribe anytime.',
  placeholder: 'Enter your email address',
  buttonLabel: 'Join Newsletter'
};
